import { about, home } from '@/constants/content';

export default function Home() {
  return (
    <div className="flex w-full flex-col items-start gap-6">
      <p className="w-full font-mono text-sm text-primary">{home.greeting}</p>
      <h1 className="text-4xl font-bold tracking-tight text-foreground sm:text-5xl">{home.name}</h1>
      <h2 className="text-2xl font-semibold text-muted-foreground sm:text-3xl">{home.headline}</h2>
      {/* <p className="max-w-xl text-muted-foreground leading-relaxed">{home.summary}</p> */}
      <div className="w-full space-y-4 border-t border-border pt-8 text-muted-foreground leading-relaxed">
        {about.paragraphs.map((text, i) => (
          <p key={i} className="w-full">
            {text}
          </p>
        ))}
      </div>
    </div>
  );
}
